module.exports = __webpack_public_path__ + "static/media/forward.77cca9c7.svg";